(function($) {
    var __ = {
        body: $('body'),
        window: $(window),
        // Scene Controller
        controller: window._animations.base.controller,
        global: window._animations.base,
        ajax :  {},
        fetch: new ScrollMagic.Scene(),
        
        splitText : {},
        // Function that runs on load
        loadAnimations: function() {
            __.pageLoadEffects();
            if (__.global.screen === "large") {
                __.pageEffects();
            }
        },
        pageLoadEffects: function(block){
            var timeline = new TimelineMax();

            if (__.global.screen === "large") {
              
                 timeline
                .add(TweenMax.from('.pg-header--logo', 0.4, __.global.animations.fade.down), '+=1')
                .add(TweenMax.from('.pg-navigation', 0.4, __.global.animations.slide.right) )
                .add(TweenMax.from('.pg-toggle--animation', 0.2, __.global.animations.fade.down), '+=0.2')
                
                .add(TweenMax.from($('.pg-single-banner--background'), 0.4, {opacity: 0} ) )
                .add(TweenMax.from('.pg-header--social', 0.4, __.global.animations.fade.left) );

                timeline
                .add(TweenMax.from('.pg-single-content', 0.4, __.global.animations.slide.up) )
                .add(TweenMax.from('.pg-single-content--container', 0.4, __.global.animations.fade.up) )
                
                .call(function() {
                    __.global.completeLoadInAnimation();
                });
            }else{

                timeline
                .add(TweenMax.from('.pg-header--logo', 0.4, __.global.animations.fade.down), '+=1')
                .add(TweenMax.from('.pg-navigation', 0.4, __.global.animations.fade.down) )
                .add(TweenMax.from('.pg-toggle--animation', 0.2, __.global.animations.fade.down), '+=0.2')
                
                .add(TweenMax.from($('.pg-single-banner--background'), 0.4, {opacity: 0} ) );

                timeline
                .add(TweenMax.from('.pg-single-content', 0.4, __.global.animations.slide.up) )
                .add(TweenMax.from('.pg-single-content--container', 0.4, __.global.animations.fade.up) )
                
                .call(function() {
                    __.global.completeLoadInAnimation();
                });
            }
            timeline.play(); //
        },
        pageEffects: function(){   
            __.bannerParallax();
        },
        bannerParallax : function(){
            var timeline = new TimelineMax();
            var banner = $('.pg-single-banner--background');
            timeline.add(TweenMax.to( banner, 0.4, { transform: 'translateY(350px)', ease:Linear.easeNone } ) );
            new ScrollMagic.Scene({
                duration: 700,
                offset: 0,
                triggerHook: 0,
            })               
            .setTween( timeline )
            .addTo(__.controller);
        },
        // Function to call to setup functionality
        setup: function() {
            __.loadAnimations();
        }
    };
    // Attach Toolbox to window 
    if (typeof window._animations === "undefined") {
        window._animations = {};
    }
    window._animations.service = __;
})(jQuery); // Fully reference jQuery after this point.